export default __webpack_public_path__ + "static/media/privacy.d85474c9.md";